const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_health-aide-finder/artifacts/6cczwlx6_SPI-logo-450.jpg.jpeg";

const sizes = {
  sm: { h: 36, gap: "gap-2" },
  md: { h: 48, gap: "gap-3" },
  lg: { h: 64, gap: "gap-3" },
};

export default function Logo({ variant = "dark", size = "md" }) {
  const s = sizes[size] || sizes.md;
  const bg =
    variant === "light"
      ? "bg-white/95 backdrop-blur p-1.5 rounded-md"
      : "";

  return (
    <div className={`inline-flex items-center ${s.gap}`} data-testid="spi-logo">
      <div className={bg}>
        <img
          src={LOGO_URL}
          alt="Swiss Premium Insurance"
          style={{ height: s.h, width: "auto", display: "block" }}
          className="object-contain"
          loading="lazy"
        />
      </div>
    </div>
  );
}
